<template>
  <div>
    <el-row type="flex" justify="space-between">
      <el-col :span="24">
        <el-tabs
          type="card"
          v-model="packsActiveTabName"
          @tab-click="onPacksActiveTabClick"
          v-shortkey="{ Enter: ['enter'] }"
          @shortkey.native="onShortKeyRouter"
        >
          <el-tab-pane
            id="tab-0"
            :key="1"
            name="packList"
            :label="$t('packs.packListTab.title')"
          >
            <el-row type="flex" justify="space-between">
              <el-col :span="24" class="grid-container-packs">
                <ag-grid-vue
                  style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
                  class="ag-theme-balham"
                  rowSelection="single"
                  :defaultColDef="defaultColDef"
                  :columnDefs="packListColumnDefs"
                  :rowData="packList"
                  :gridOptions="packListGridOptions"
                  @grid-ready="onPackListGridReady"
                  @first-data-rendered="onPackListFirstDataRendered"
                  @modelUpdated="onPackListModelUpdated"
                  @rowSelected="onPackListRowSelected"
                  @rowDoubleClicked="onPackListRowDoubleClicked"
                  @cellContextMenu="onPackListRowRightClicked"
                ></ag-grid-vue>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              style="margin-top: 10px"
            >
              <el-col :span="20">
                <el-button
                  type="primary"
                  size="small"
                  :disabled="returnBtnDisabled"
                  @click="onReturnBtn"
                  v-shortkey="{ Del: ['del'], Minus: ['-'] }"
                  @shortkey.native="onShortKeyRouter"
                  ><span class="key-name">Del</span
                  >{{ $t("common.buttons.return") }}</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  :disabled="postingBtnDisabled"
                  @click="onPostingBtn"
                  v-shortkey="{ F9: ['f9'] }"
                  @shortkey.native="onShortKeyRouter"
                  ><span class="key-name">F9</span
                  >{{ $t("common.buttons.distribute") }}</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  :disabled="postponeBtnDisabled"
                  @click="onPostponeBtn"
                  v-shortkey="{ ShiftF9: ['shift', 'f9'] }"
                  @shortkey.native="onShortKeyRouter"
                  ><span class="key-name">Shift+F9</span
                  >{{ $t("common.buttons.postpone") }}</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  :disabled="postingAllBtnDisabled"
                  @click="onPostingAllBtn"
                  v-shortkey="{ CtrlF9: ['ctrl', 'f9'] }"
                  @shortkey.native="onShortKeyRouter"
                  ><span class="key-name">Ctrl+F9</span
                  >{{ $t("common.buttons.distributeAll") }}</el-button
                >
              </el-col>
              <el-col :span="4" style="text-align:right;">
                <el-button
                  type="primary"
                  size="small"
                  @click="onRefreshPackListBtn"
                  >{{ $t("common.buttons.refreshList") }}</el-button
                >
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane
            v-if="packSelectedVisible"
            id="tab-1"
            :key="2"
            name="packSelected"
            :label="packSelectedTitle"
          >
            <el-row type="flex" justify="space-between">
              <el-col :span="24" class="grid-container-packSelected">
                <ag-grid-vue
                  style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
                  class="ag-theme-balham"
                  rowSelection="single"
                  :defaultColDef="defaultColDef"
                  :columnDefs="packSelectedColumnDefs"
                  :rowData="packSelected"
                  :gridOptions="packSelectedGridOptions"
                  @grid-ready="onPackSelectedGridReady"
                  @first-data-rendered="onPackSelectedFirstDataRendered"
                  @modelUpdated="onPackSelectedModelUpdated"
                  @rowSelected="onPackSelectedRowSelected"
                  @cellContextMenu="onPackSelectedRowRightClicked"
                ></ag-grid-vue>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="8">
                <el-row type="flex" justify="space-between">
                  <el-col :span="24" class="grid-container-countbands">
                    <ag-grid-vue
                      style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
                      class="ag-theme-balham"
                      rowSelection="single"
                      :defaultColDef="defaultColDef"
                      :columnDefs="countbandsColumnDefs"
                      :rowData="countbands"
                      :gridOptions="countbandsGridOptions"
                      @grid-ready="onCountbandsGridReady"
                      @first-data-rendered="onCountbandsFirstDataRendered"
                      @modelUpdated="onCountbandsModelUpdated"
                      @rowSelected="onCountbandsRowSelected"
                      @rowDoubleClicked="onCountbandsRowDoubleClicked"
                      @cellContextMenu="onCountbandsRowRightClicked"
                    ></ag-grid-vue>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-table
                      :data="countbandsTotal"
                      size="mini"
                      border
                      :show-header="false"
                      :cell-class-name="countbandsTotalTableCellStyle"
                      style="width: 100%"
                    >
                      <el-table-column prop="name" align="left" width="220">
                      </el-table-column>
                      <el-table-column prop="amount" align="right">
                      </el-table-column>
                      <el-table-column prop="sum" align="right">
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="16">
                <el-row type="flex" justify="space-between">
                  <el-col :span="24" class="grid-container-onecountband">
                    <ag-grid-vue
                      style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
                      class="ag-theme-balham"
                      rowSelection="single"
                      :defaultColDef="defaultColDef"
                      :columnDefs="oneCountbandColumnDefs"
                      :rowData="oneCountband"
                      :gridOptions="oneCountbandGridOptions"
                      @grid-ready="onOneCountbandGridReady"
                      @first-data-rendered="onOneCountbandFirstDataRendered"
                      @modelUpdated="onOneCountbandModelUpdated"
                      @rowSelected="onOneCountbandRowSelected"
                      @rowDoubleClicked="onOneCountbandRowDoubleClicked"
                      @cellContextMenu="onOneCountbandRowRightClicked"
                    ></ag-grid-vue>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="11">
                    <el-table
                      :data="oneCountbandTotal"
                      size="mini"
                      border
                      :show-header="false"
                      :cell-class-name="oneCountbandTotalTableCellStyle"
                      style="width: 100%"
                    >
                      <el-table-column prop="name" align="left" width="220">
                      </el-table-column>
                      <el-table-column prop="amount" align="right">
                      </el-table-column>
                      <el-table-column prop="sum" align="right">
                      </el-table-column>
                    </el-table>
                  </el-col>
                  <el-col :span="13" class="blank-element"></el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              style="margin-top: 10px;"
            >
              <el-col :span="8">
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-button-group
                      style="margin-right: 20px; margin-top: -1px;"
                    >
                      <el-button
                        type="primary"
                        size="small"
                        :disabled="countbandsAddBtnDisabled"
                        @click="onCountbandsAddBtn"
                        v-shortkey="{ Insert: ['insert'], Plus: ['+'] }"
                        @shortkey.native="onShortKeyRouter"
                        ><span class="key-name">Ins</span
                        >{{ $t("common.buttons.add") }}</el-button
                      >
                      <el-button
                        type="primary"
                        size="small"
                        :disabled="countbandsEditBtnDisabled"
                        @click="onCountbandsEditBtn"
                        v-shortkey="{ F4: ['f4'], Star: ['*'] }"
                        @shortkey.native="onShortKeyRouter"
                        ><span class="key-name">F4</span
                        >{{ $t("common.buttons.edit") }}</el-button
                      >
                      <el-button
                        type="primary"
                        size="small"
                        :disabled="countbandsDeleteBtnDisabled"
                        @click="onCountbandsDeleteBtn"
                        v-shortkey="{ Del: ['del'], Minus: ['-'] }"
                        @shortkey.native="onShortKeyRouter"
                        ><span class="key-name">Del</span
                        >{{ $t("common.buttons.remove") }}</el-button
                      >
                    </el-button-group>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="16">
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-button-group
                      style="margin-right: 20px; margin-top: -1px;"
                    >
                      <el-button
                        type="primary"
                        size="small"
                        :disabled="oneCountbandAddBtnDisabled"
                        @click="onOneCountbandAddBtn"
                        v-shortkey="{
                          CtrlInsert: ['ctrl', 'insert'],
                          CtrlPlus: ['ctrl', '+']
                        }"
                        @shortkey.native="onShortKeyRouter"
                        ><span class="key-name">Ctrl+Ins</span
                        >{{ $t("common.buttons.add") }}</el-button
                      >
                      <el-button
                        type="primary"
                        size="small"
                        :disabled="oneCountbandEditBtnDisabled"
                        @click="onOneCountbandEditBtn"
                        v-shortkey="{
                          CtrlF4: ['ctrl', 'f4'],
                          CtrlStar: ['ctrl', '*']
                        }"
                        @shortkey.native="onShortKeyRouter"
                        ><span class="key-name">Ctrl+F4</span
                        >{{ $t("common.buttons.edit") }}</el-button
                      >
                      <el-button
                        type="primary"
                        size="small"
                        :disabled="oneCountbandDeleteBtnDisabled"
                        @click="onOneCountbandDeleteBtn"
                        v-shortkey="{
                          CtrlDel: ['ctrl', 'del'],
                          CtrlMinus: ['ctrl', '-']
                        }"
                        @shortkey.native="onShortKeyRouter"
                        ><span class="key-name">Ctrl+Del</span
                        >{{ $t("common.buttons.remove") }}</el-button
                      >
                      <el-button
                        type="primary"
                        size="small"
                        :disabled="oneCountbandDeleteAllBtnDisabled"
                        @click="onOneCountbandDeleteAllBtn"
                        v-shortkey="{
                          ShiftDel: ['shift', 'del'],
                          ShiftMinus: ['shift', '-']
                        }"
                        @shortkey.native="onShortKeyRouter"
                        ><span class="key-name">Shift+Del</span
                        >{{ $t("common.buttons.removeAll") }}</el-button
                      >
                    </el-button-group>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between" style="margin-top: 10px">
      <el-col :span="24">
        <el-button
          type="primary"
          size="small"
          :disabled="checkBtnDisabled"
          @click="onCheckBtn"
          v-shortkey="{ F11: ['f11'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F11</span
          >{{ $t("common.buttons.check") }}</el-button
        >
        <el-button
          v-if="infoPayBtnVisible"
          type="primary"
          size="small"
          :disabled="infoPayBtnDisabled"
          @click="onInfoPayBtn"
          >{{ $t("common.buttons.infoPay") }}</el-button
        >
      </el-col>
    </el-row>

    <el-dialog
      width="40%"
      :title="$t('packs.packListTab.reasonReturningPackForm.modal.title')"
      :visible.sync="reasonReturningPackModal"
      :close-on-click-modal="false"
      @close="reasonReturningPackModalHide"
      v-draggable
    >
      <el-form
        :model="reasonReturningPackForm"
        :rules="reasonReturningPackRules"
        ref="reasonReturningPackForm"
      >
        <el-row type="flex" justify="space-between" :gutter="5">
          <el-col :span="5">
            <el-form-item>
              <div>
                <span class="red-star">*</span>
                {{
                  $t(
                    "packs.packListTab.reasonReturningPackForm.modal.form.reasons"
                  )
                }}
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item>
              <currency-input
                placeholder=""
                v-model="reasonReturningPackForm.codereasonCode"
                @blur="onChangeReasonRetPackCodereasonCode"
                @keyup.enter.native="onChangeReasonRetPackCodereasonCode"
                :precision="0"
                class="el-input--small el-input__inner"
                style="width: 100%; height: 37px; line-height: 37px;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item prop="codereason">
              <el-select
                v-model="reasonReturningPackForm.codereason"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="item in params.codereason.data"
                  :key="item.codereason"
                  :label="item.namereason"
                  :value="item.codereason"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="reasonReturningPackSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button
              type="plain"
              size="small"
              @click="reasonReturningPackModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog
      :title="countbandsEditTitle"
      :visible.sync="countbandsEditModal"
      :close-on-click-modal="false"
      @close="countbandsEditModalHide"
      :width="dialogWidth"
      v-draggable
    >
      <el-form
        :model="countbandsEditForm"
        :rules="countbandsEditRules"
        ref="countbandsEditForm"
      >
        <el-row type="flex" justify="space-between" :gutter="10">
          <el-col :span="6" style="text-align:right;">
            <el-form-item>
              <div>
                {{ countbandsEditNumber }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="text-align:left;">
            <el-form-item prop="number">
              <el-input-number
                placeholder="0"
                v-model="countbandsEditForm.number"
                :precision="0"
                :controls="false"
                disabled
                size="small"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;"> </el-col>
        </el-row>
        <el-row type="flex" justify="space-between" :gutter="10">
          <el-col :span="6" style="text-align:right;">
            <el-form-item>
              <div>
                {{ countbandsEditQuantity }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="text-align:left;">
            <el-form-item prop="quantity">
              <el-input-number
                placeholder="0"
                v-model="countbandsEditForm.quantity"
                :precision="0"
                :controls="false"
                size="small"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="text-align:right;">
            <el-form-item>
              <div>
                {{
                  $t("packs.packSelectedTab.countbandsEditForm.form.totalSum")
                }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="text-align:left;">
            <el-form-item prop="totalSum">
              <currency-input
                placeholder="0.00"
                v-model.lazy="countbandsEditForm.totalSum"
                class="el-input--small el-input__inner"
                style="width: 100%; height: 32px; line-height: 32px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <el-button
              v-if="countbandsEditStatus === 'add'"
              type="primary"
              size="small"
              @click="countbandsEditFormSubmit('insert')"
              native-type="submit"
              v-shortkey="{
                Insert: ['insert'],
                Plus: ['+']
              }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">Ins</span
              >{{ $t("common.buttons.add") }}</el-button
            >
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="countbandsEditFormSubmit('submit')"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button
              type="plain"
              size="small"
              @click="countbandsEditModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <ErrorPayments></ErrorPayments>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { $ } from "moneysafe";
import ErrorPayments from "@/components/ErrorPayments";
import { setGridView } from "@/helpers/grid";
import { dialogWidth } from "@/mixins/dialogWidth";

export default {
  name: "packs",
  props: ["type"],
  components: {
    AgGridVue,
    ErrorPayments
  },
  mixins: [dialogWidth],
  data() {
    const validateReason = (rule, value, callback) => {
      if (!value) {
        callback(
          new Error(this.$t("common.validations.reasonReturnPack.message"))
        );
      } else {
        callback();
      }
    };
    const validateQuantity = (rule, value, callback) => {
      const message =
        this.type === "1"
          ? this.$t("common.validations.massInputQuantity.quantityGrtZero")
          : this.$t("common.validations.massInputQuantity.subscribersGrtZero");
      if (value <= 0) {
        callback(new Error(message));
      } else if (!value) {
        callback(
          new Error(this.$t("common.validations.massInputQuantity.message"))
        );
      } else {
        callback();
      }
    };
    const validateTotalSum = (rule, value, callback) => {
      if (value <= 0) {
        callback(
          new Error(this.$t("common.validations.massInputTotalSum.sumGrtZero"))
        );
      } else if (!value) {
        callback(
          new Error(this.$t("common.validations.massInputTotalSum.message"))
        );
      } else {
        callback();
      }
    };
    return {
      agGridModules: AllCommunityModules,
      agGridlocaleText: null,
      packListGridOptions: null,
      packListGridApi: null,
      packListColumnApi: null,
      packSelectedGridOptions: null,
      packSelectedGridApi: null,
      packSelectedColumnApi: null,
      countbandsGridOptions: null,
      countbandsGridApi: null,
      countbandsColumnApi: null,
      oneCountbandGridOptions: null,
      oneCountbandGridApi: null,
      oneCountbandColumnApi: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      packListColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.npack"),
          headerTooltip: this.$t("common.gridColumns.npack"),
          field: "npack",
          tooltipField: "npack",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.summa"),
          headerTooltip: this.$t("common.gridColumns.summa"),
          field: "summa",
          tooltipField: "summa",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.calcCountbandName(),
          headerTooltip: this.calcCountbandName(),
          field: "countband",
          tooltipField: "countband",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.calcQuantityName(),
          headerTooltip: this.calcQuantityName(),
          field: "quantity",
          tooltipField: "quantity",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.kindname"),
          headerTooltip: this.$t("common.gridColumns.kindname"),
          field: "kindname",
          tooltipField: "kindname",
          cellClass: "reporting-month"
        },
        {
          headerName: this.calcDatebankName(),
          headerTooltip: this.calcDatebankName(),
          field: "datebank",
          tooltipField: "datebank",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.namefirme"),
          headerTooltip: this.$t("common.gridColumns.namefirme"),
          field: "namefirme",
          tooltipField: "namefirme",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.nameaccount"),
          headerTooltip: this.$t("common.gridColumns.nameaccount"),
          field: "rcount",
          tooltipField: "rcount",
          cellClass: "reporting-month",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        }
      ],
      packSelectedColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.summa"),
          headerTooltip: this.$t("common.gridColumns.summa"),
          field: "summa",
          tooltipField: "summa",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.calcQuantityName(),
          headerTooltip: this.calcQuantityName(),
          field: "quantity",
          tooltipField: "quantity",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.calcCountbandName(),
          headerTooltip: this.calcCountbandName(),
          field: "countband",
          tooltipField: "countband",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.calcDatebankName(),
          headerTooltip: this.calcDatebankName(),
          field: "datebank",
          tooltipField: "datebank",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.organization"),
          headerTooltip: this.$t("common.gridColumns.organization"),
          field: "namefirme",
          tooltipField: "namefirme",
          cellClass: "reporting-month"
        }
      ],
      countbandsColumnDefs: [
        {
          headerName: this.calcCountbandsName(),
          headerTooltip: this.calcCountbandsName(),
          children: [
            {
              headerName: this.$t("common.gridColumns.nband"),
              headerTooltip: this.$t("common.gridColumns.nband"),
              field: "nband",
              tooltipField: "nband",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.countpay"),
              headerTooltip: this.$t("common.gridColumns.countpay"),
              field: "countpay",
              tooltipField: "countpay",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summband",
              tooltipField: "summband",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            }
          ]
        }
      ],
      oneCountbandColumnDefs: [
        {
          headerName: "",
          headerTooltip: "",
          children: [
            {
              headerName: this.$t("common.gridColumns.abcodeNumber"),
              headerTooltip: this.$t("common.gridColumns.abcodeNumber"),
              field: "abcode",
              tooltipField: "abcode"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summpay",
              tooltipField: "summpay",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "dateclient",
              tooltipField: "dateclient",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.nameplat"),
              headerTooltip: this.$t("common.gridColumns.nameplat"),
              field: "nameplat",
              tooltipField: "nameplat",
              cellClass: "reporting-month"
            },
            {
              headerName: this.$t("common.gridColumns.fio"),
              headerTooltip: this.$t("common.gridColumns.fio"),
              field: "fio",
              tooltipField: "fio",
              cellClass: "reporting-month"
            },
            {
              headerName: this.$t("common.gridColumns.adress"),
              headerTooltip: this.$t("common.gridColumns.adress"),
              field: "adress",
              tooltipField: "adress",
              cellClass: "reporting-month"
            },
            {
              headerName: this.$t("common.gridColumns.dateBeginAction"),
              headerTooltip: this.$t("common.gridColumns.dateBeginAction"),
              field: "datebegin",
              tooltipField: "datebegin",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.calcDateendName(),
              headerTooltip: this.calcDateendName(),
              field: "dateend",
              tooltipField: "dateend",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            }
          ]
        }
      ],
      currentPackListRowSelected: null,
      packsActiveTabName: "packList",
      packsActiveTabPrevious: "packList",
      returnBtnDisabled: true,
      postingBtnDisabled: true,
      postponeBtnDisabled: true,
      postingAllBtnDisabled: true,
      checkBtnDisabled: true,
      infoPayBtnDisabled: true,
      infoPayBtnVisible: false,
      reasonReturningPackModal: false,
      reasonReturningPackForm: {
        codereasonCode: null,
        codereason: null
      },
      reasonReturningPackRules: {
        codereason: [
          { required: true, validator: validateReason, trigger: "blur" }
        ]
      },
      pressedButton: "",
      postingAllCount: 0,
      postingAllNpacks: [],
      currentPackListLastRow: null,

      // tab-1
      packSelectedVisible: false,
      packSelectedTitle: "",
      currentPackSelectedRowSelected: null,
      currentCountbandsRowSelected: null,
      currentOneCountbandRowSelected: null,
      countbandsRowCount: 0,
      countbandsAddBtnDisabled: false,
      countbandsEditBtnDisabled: true,
      countbandsDeleteBtnDisabled: true,
      oneCountbandAddBtnDisabled: true,
      oneCountbandEditBtnDisabled: true,
      oneCountbandDeleteBtnDisabled: true,
      oneCountbandDeleteAllBtnDisabled: true,
      countbandsTotal: [
        {
          name: this.$t("packs.packSelectedTab.countbandsTotal.pack"),
          amount: 0,
          sum: 0
        },
        {
          name:
            this.type === "1"
              ? this.$t(
                  "packs.packSelectedTab.countbandsTotal.payments.countbands"
                )
              : this.$t(
                  "packs.packSelectedTab.countbandsTotal.subsidies.lists"
                ),
          amount: 0,
          sum: 0
        },
        {
          name:
            this.type === "1"
              ? this.$t(
                  "packs.packSelectedTab.countbandsTotal.payments.receipts"
                )
              : this.$t(
                  "packs.packSelectedTab.countbandsTotal.subsidies.socials"
                ),
          amount: 0,
          sum: 0
        }
      ],
      oneCountbandTotal: [
        {
          name:
            this.type === "1"
              ? this.$t(
                  "packs.packSelectedTab.countbandsTotal.payments.countband"
                )
              : this.$t("packs.packSelectedTab.countbandsTotal.subsidies.list"),
          amount: 0,
          sum: 0
        },
        {
          name:
            this.type === "1"
              ? this.$t(
                  "packs.packSelectedTab.countbandsTotal.payments.receipts"
                )
              : this.$t(
                  "packs.packSelectedTab.countbandsTotal.subsidies.socials"
                ),
          amount: 0,
          sum: 0
        }
      ],
      countbandsEditModal: false,
      countbandsEditStatus: "",
      countbandsSubmitStatus: "",
      countbandsEditForm: {
        number: 0,
        quantity: 0,
        totalSum: 0
      },
      countbandsEditRules: {
        quantity: [
          { required: true, validator: validateQuantity, trigger: "blur" }
        ],
        totalSum: [
          { required: true, validator: validateTotalSum, trigger: "blur" }
        ]
      },
      runCalcNextCountband: false,
      countbandsLastRow: null,
      oneCountbandLastRow: null
    };
  },
  created() {
    this.packsActiveTabName = "packList";
    this.packsActiveTabPrevious = "packList";

    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.packListGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText,
      rowClassRules: {
        "ag-state-night-posting": params => params.data.status == "1"
      }
    };

    this.packSelectedGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.countbandsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.oneCountbandGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.infoPayBtnVisible =
      this.params.goptions.cancreatepackbyps === "yes" ? true : false;
  },
  computed: {
    ...mapGetters([
      "packList",
      "infoPay",
      "packVerification",
      "returnPack",
      "holdPack",
      "postingPrepare",
      "postingComplete",
      "postingAllPrepare",
      "errorPaymentsModal",
      "paymentModal",
      "packSelected",
      "countbands",
      "countbandsTotalSum",
      "oneCountband",
      "oneCountbandTotalSum",
      "countbandsEdit",
      "countbandsDelete",
      "oneCountbandPaymentDelete",
      "paymentSubmit",
      "countbandPaymentRefresh",
      "params"
    ]),
    calcLocalStorageName: function() {
      return this.type === "1" ? "payments" : "subsidies";
    },
    countbandsEditTitle: function() {
      return this.type === "1"
        ? this.$t(
            "packs.packSelectedTab.countbandsEditForm.modal.title.payments"
          )
        : this.$t(
            "packs.packSelectedTab.countbandsEditForm.modal.title.subsidies"
          );
    },
    countbandsEditNumber: function() {
      return this.type === "1"
        ? this.$t(
            "packs.packSelectedTab.countbandsEditForm.form.number.payments"
          )
        : this.$t(
            "packs.packSelectedTab.countbandsEditForm.form.number.subsidies"
          );
    },
    countbandsEditQuantity: function() {
      return this.type === "1"
        ? this.$t(
            "packs.packSelectedTab.countbandsEditForm.form.quantity.payments"
          )
        : this.$t(
            "packs.packSelectedTab.countbandsEditForm.form.quantity.subsidies"
          );
    }
  },
  watch: {
    infoPay: function(value) {
      if (value) {
        this.$alert(value, "", {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          type: "info",
          callback: () => {
            this.clearInfoPay();
          }
        });
      }
    },
    packVerification: function(value) {
      if (value) {
        this.checkQuestionsAndErrors(value);
      }
    },
    "reasonReturningPackForm.codereason": function(value) {
      this.reasonReturningPackForm.codereasonCode = +value || null;
    },
    returnPack: function(value) {
      if (value) {
        this.currentPackListLastRow = value.data;
        this.refreshPackList();
      }
    },
    holdPack: function(value) {
      if (value) {
        this.currentPackListLastRow = value.data;
        this.refreshPackList();
      }
    },
    postingPrepare: function(value) {
      if (value) {
        if (value.errormess.length > 0) {
          const message = value.errormess[0];

          this.$alert(message, "", {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type: "error"
          });
        } else {
          this.$confirm(
            this.$t("packs.packListTab.confirm.postingPrepare"),
            "",
            {
              confirmButtonText: this.$t("common.buttons.confirmYes"),
              cancelButtonText: this.$t("common.buttons.confirmNo"),
              cancelButtonClass: "cancel-button",
              type: "info"
            }
          )
            .then(() => {
              this.pressedButton = "posting";
              this.checkQuestionsAndErrors(value);
            })
            .catch(() => {});
        }
      }
    },
    postingComplete: function(value) {
      if (value) {
        this.posting(value);
      }
    },
    postingAllPrepare: function(value) {
      if (value) {
        if (value.rows === 0) {
          this.$alert(
            this.$t("packs.packListTab.alert.postingAllPrepare"),
            "",
            {
              confirmButtonText: this.$t("common.buttons.confirmOk"),
              type: "info"
            }
          );
        } else {
          let message = `<p>${this.$t(
            "packs.packListTab.confirm.postingAllPrepare.messageCountPacks"
          )} - ${value.rows}.</p>`;
          message += `<p>${this.$t(
            "packs.packListTab.confirm.postingAllPrepare.messagePostingAll"
          )}</p>`;

          this.$confirm(message, "", {
            confirmButtonText: this.$t("common.buttons.confirmYes"),
            cancelButtonText: this.$t("common.buttons.confirmNo"),
            cancelButtonClass: "cancel-button",
            type: "info",
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              this.pressedButton = "postingAll";
              this.postingAllCount = 0;
              this.postingAllNpacks = value.data[0];
              this.postingAll();
            })
            .catch(() => {});
        }
      }
    },
    errorPaymentsModal: function(value) {
      if (!value) {
        if (this.pressedButton === "posting") {
          this.refreshPackList();
        } else if (this.pressedButton === "postingAll") {
          this.postingAllContinue();
        }
      }
    },
    countbands: function(value) {
      if (value && this.runCalcNextCountband) {
        this.calcNextCountband(value); // расчет следующего значения формы Бандероль в режиме добавления
      }
    },
    countbandsEdit: function(value) {
      if (value.rows > 0) {
        this.countbandsLastRow = value.nob;
        this.runCalcNextCountband = false;
        if (this.countbandsSubmitStatus === "insert") {
          const { countband } = this.currentPackSelectedRowSelected;

          if ($(value.nband).toNumber() < $(countband).toNumber()) {
            this.runCalcNextCountband = true;
          } else {
            this.countbandsEditModal = false;
          }
        } else if (this.countbandsSubmitStatus === "submit") {
          this.countbandsEditModal = false;
        }
        this.refreshCountbandsList();
      }
    },
    countbandsDelete: function(value) {
      if (value.rows > 0) {
        this.countbandsLastRow = null;
        this.refreshCountbandsList();
      }
    },
    oneCountbandPaymentDelete: function(value) {
      if (value.type === "success") {
        this.oneCountbandLastRow = null;
        this.refreshOneCountbandList();
      } else if (value.type === "error") {
        this.$alert(value.message, "", {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          type: "error",
          callback: () => {
            this.oneCountbandLastRow = null;
            this.refreshOneCountbandList();
          }
        });
      }
    },
    paymentSubmit: function(value) {
      if (value) {
        this.oneCountbandLastRow = `${value.data}`;
        this.refreshOneCountbandList();
      }
    }
  },
  methods: {
    ...mapMutations([
      "setGridContextMenuKey",
      "setGridContextMenuEvent",
      "setGridContextMenuModal",
      "setErrorPaymentsModal",
      "setErrorPaymentsSearchParams",
      "setPackSelected",
      "setCountbandPayment",
      "clearInfoPay",
      "clearPackVerification",
      "clearReturnPack",
      "clearHoldPack",
      "clearPostingPrepare",
      "clearPostingComplete",
      "clearPostingAllPrepare",
      "clearPackSelected",
      "clearCountbands",
      "clearOneCountband",
      "clearCountbandsEdit",
      "clearCountbandsDelete",
      "clearOneCountbandPaymentDelete"
    ]),
    ...mapActions([
      "getPackList",
      "getInfoPay",
      "getPackVerification",
      "callReturnPack",
      "callHoldPack",
      "callPostingPrepare",
      "callPostingComplete",
      "callPostingAllPrepare",
      "getCountbands",
      "getOneCountband",
      "callCountbandsInsert",
      "callCountbandsEdit",
      "callCountbandsDelete",
      "countbandPaymentOneDelete",
      "countbandPaymentAllDelete"
    ]),
    calcCountbandName() {
      return this.type === "1"
        ? this.$t("common.gridColumns.countbands")
        : this.$t("common.gridColumns.lists");
    },
    calcCountbandsName() {
      return this.type === "1"
        ? this.$t("packs.packSelectedTab.countbandsName.payments")
        : this.$t("packs.packSelectedTab.countbandsName.subsidies");
    },
    calcOneCountbandName() {
      return this.type === "1"
        ? this.$t("packs.packSelectedTab.oneCountbandName.payments")
        : this.$t("packs.packSelectedTab.oneCountbandName.subsidies");
    },
    calcQuantityName() {
      return this.type === "1"
        ? this.$t("common.gridColumns.quantitys")
        : this.$t("common.gridColumns.subsidiesSocBenefits");
    },
    calcDatebankName() {
      return this.type === "1"
        ? this.$t("common.gridColumns.datebank")
        : this.$t("common.gridColumns.appointmentDate");
    },
    calcDateendName() {
      return this.type === "1"
        ? this.$t("common.gridColumns.dateReading")
        : this.$t("common.gridColumns.dateEndAction");
    },
    showQuestionPackVerification(value, index) {
      const questionMessages = value.question[index];
      let question = "";
      if (questionMessages.length > 0) {
        questionMessages.forEach((item, index) => {
          question +=
            index === 0
              ? `<p><strong>${item}</strong></p>`
              : item === ""
              ? `<br />`
              : `<p>${item}</p>`;
        });
      }

      this.$confirm(question, "", {
        confirmButtonText: this.$t("common.buttons.confirmYes"),
        cancelButtonText: this.$t("common.buttons.confirmNo"),
        cancelButtonClass: "cancel-button",
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          if (this.pressedButton === "check") {
            this.lastMessagePackVerification(value, ++index);
          }
        })
        .catch(() => {
          if (value.question.length > index + 1) {
            this.showQuestionPackVerification(value, ++index);
          } else {
            if (this.pressedButton === "check") {
              this.lastMessagePackVerification(value, ++index);
            }
          }
        });
    },
    lastMessagePackVerification(value, count) {
      const countband = count || value.countband;
      const errors = count || 0;

      let message = `<p><strong>${this.$t(
        "packs.packListTab.alert.lastMessagePackVerification.verificationCompleted"
      )}</strong></p>`;
      message += `<p>${this.$t(
        "packs.packListTab.alert.lastMessagePackVerification.checked"
      )} ${value.namemess}: ${countband}</p>`;
      message += `<p>${this.$t(
        "packs.packListTab.alert.lastMessagePackVerification.bugsFound"
      )} ${errors}</p>`;

      this.$alert(message, "", {
        confirmButtonText: this.$t("common.buttons.confirmOk"),
        type: "info",
        dangerouslyUseHTMLString: true,
        callback: () => {
          this.clearPackVerification();
        }
      });
    },
    checkQuestionsAndErrors(value) {
      // errormessfinish
      if (value.errormessfinish.length > 0) {
        const errorMessages = value.errormessfinish[0];
        let message = "";
        if (errorMessages.length > 0) {
          errorMessages.forEach((item, index) => {
            message +=
              index === 0
                ? `<p><strong>${item}</strong></p>`
                : `<p>${item}</p>`;
          });
        }

        this.$alert(message, "", {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          type: "error",
          dangerouslyUseHTMLString: true,
          callback: () => {
            if (this.pressedButton === "check") {
              this.lastMessagePackVerification(value, null);
            }
          }
        });
        // question
      } else if (value.question.length > 0) {
        this.showQuestionPackVerification(value, 0);
        // empty
      } else {
        if (this.pressedButton === "check") {
          this.lastMessagePackVerification(value, null);
        } else if (this.pressedButton === "postpone") {
          const { npack, datebeginfact } = this.currentPackListRowSelected;

          this.currentPackListLastRow = null;
          this.clearHoldPack();
          this.callHoldPack({ npack, datebeginfact });
        } else if (this.pressedButton === "posting") {
          const { npack } = this.currentPackListRowSelected;

          this.clearPostingComplete();
          this.callPostingComplete({ npack });
        }
      }
    },
    posting(value) {
      const { message, type, npack } = value;

      if (this.pressedButton === "posting") {
        this.$alert(message, "", {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          type,
          callback: () => {
            if (type === "success") {
              this.refreshPackList();
            } else if (type === "warning") {
              this.setErrorPaymentsSearchParams({
                abcode: "",
                abcodeTypeSearch: "",
                sumPayBegin: "",
                sumPayEnd: "",
                sumPayTypeSearch: "",
                dateBankBegin: "",
                dateBankEnd: "",
                dateBankTypeSearch: "",
                datePayBegin: "",
                datePayEnd: "",
                datePayTypeSearch: "",
                dateChangeBegin: "",
                dateChangeEnd: "",
                dateChangeTypeSearch: "",
                errorType: "",
                npack, // ### хардкод: 28031154, 28038375 (30 платежей)
                datePayFrom: "",
                datePayTo: "",
                kindpay: "",
                codefirme: "",
                note: "",
                noteTypeSearch: ""
              });
              this.setErrorPaymentsModal(true);
            }
          }
        });
      } else if (this.pressedButton === "postingAll") {
        if (type === "success") {
          this.postingAllContinue();
        } else if (type === "error") {
          this.$alert(message, "", {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type,
            callback: () => {
              this.postingAllContinue();
            }
          });
        } else if (type === "warning") {
          this.$alert(message, "", {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type,
            callback: () => {
              if (type === "warning") {
                this.setErrorPaymentsSearchParams({
                  abcode: "",
                  abcodeTypeSearch: "",
                  sumPayBegin: "",
                  sumPayEnd: "",
                  sumPayTypeSearch: "",
                  dateBankBegin: "",
                  dateBankEnd: "",
                  dateBankTypeSearch: "",
                  datePayBegin: "",
                  datePayEnd: "",
                  datePayTypeSearch: "",
                  dateChangeBegin: "",
                  dateChangeEnd: "",
                  dateChangeTypeSearch: "",
                  errorType: "",
                  npack,
                  datePayFrom: "",
                  datePayTo: "",
                  kindpay: "",
                  codefirme: "",
                  note: "",
                  noteTypeSearch: ""
                });
                this.setErrorPaymentsModal(true);
              }
            }
          });
        }
      }
    },
    postingAll() {
      const npack = this.postingAllNpacks[this.postingAllCount];

      this.clearPostingComplete();
      this.callPostingComplete({ npack });
    },
    postingAllContinue() {
      if (this.postingAllCount < this.postingAllNpacks.length - 1) {
        this.postingAllCount += 1;
        this.postingAll();
      } else {
        this.postingAllCount = 0;
        this.postingAllNpacks = [];

        this.$alert(this.$t("packs.packListTab.alert.postingAllContinue"), "", {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          type: "info",
          callback: () => {
            this.refreshPackList();
          }
        });
      }
    },
    onPackListGridReady(params) {
      this.packListGridApi = params.api;
      this.packListColumnApi = params.columnApi;

      this.refreshPackList();
    },
    onPackListFirstDataRendered(event) {
      setGridView(
        `wb-packs-grid-${this.calcLocalStorageName}-packList`,
        event,
        "optimal"
      );
    },
    onPackListRowRightClicked(event) {
      this.setGridContextMenuKey(
        `wb-packs-grid-${this.calcLocalStorageName}-packList`
      );
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onPackListModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      this.returnBtnDisabled = this.postingBtnDisabled = this.postponeBtnDisabled = this.postingAllBtnDisabled = this.checkBtnDisabled = this.infoPayBtnDisabled =
        rowCount === 0 ? true : false;

      this.packSelectedVisible = rowCount === 0 ? false : true;

      params.api.forEachNode(node => {
        if (node.data.npack === this.currentPackListLastRow) {
          node.setSelected(true);
          params.api.ensureIndexVisible(node.rowIndex);
        } else {
          node.rowIndex ? 0 : node.setSelected(true);
        }
      });
    },
    onPackListRowSelected(params) {
      if (params.node.selected) {
        this.currentPackListRowSelected = params.node.data;

        const { mess, status, npack } = this.currentPackListRowSelected;
        this.infoPayBtnDisabled = mess === "1" ? false : true;
        this.postponeBtnDisabled = status === "1" ? true : false;

        if (status === "0") {
          this.packSelectedTitle = `${this.$t(
            "packs.packSelectedTab.title"
          )}${npack}`;
          this.packSelectedVisible = true;
        } else if (status === "1") {
          this.packSelectedVisible = false;
        }
      }
    },
    onPackListRowDoubleClicked() {
      if (this.packSelectedVisible) {
        this.packsActiveTabName = "packSelected";

        const tab = { name: "packSelected" };
        this.onPacksActiveTabClick(tab);
      }
    },
    onPackSelectedGridReady(params) {
      this.packSelectedGridApi = params.api;
      this.packSelectedColumnApi = params.columnApi;
    },
    onPackSelectedFirstDataRendered(event) {
      setGridView(
        `wb-packs-grid-${this.calcLocalStorageName}-packSelected`,
        event,
        "optimal"
      );
    },
    onPackSelectedModelUpdated(params) {
      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onPackSelectedRowSelected(params) {
      if (params.node.selected) {
        this.currentPackSelectedRowSelected = params.node.data;

        const { quantity, summa } = this.currentPackSelectedRowSelected;

        this.countbandsTotal[0].amount = $(quantity).toNumber();
        this.countbandsTotal[0].sum = $(summa).toFixed();
      }
    },
    onPackSelectedRowRightClicked(event) {
      this.setGridContextMenuKey(
        `wb-packs-grid-${this.calcLocalStorageName}-packSelected`
      );
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onCountbandsGridReady(params) {
      this.countbandsGridApi = params.api;
      this.countbandsColumnApi = params.columnApi;
    },
    onCountbandsFirstDataRendered(event) {
      setGridView(
        `wb-packs-grid-${this.calcLocalStorageName}-countbands`,
        event,
        "optimal"
      );
    },
    onCountbandsRowRightClicked(event) {
      this.setGridContextMenuKey(
        `wb-packs-grid-${this.calcLocalStorageName}-countbands`
      );
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onCountbandsModelUpdated(params) {
      // console.log("onCountbandsModelUpdated");

      this.countbandsRowCount = params.api.getDisplayedRowCount();

      this.countbandsEditBtnDisabled = this.countbandsDeleteBtnDisabled =
        this.countbandsRowCount === 0 ? true : false;

      const { countband, sband, countpay, sumpay } = this.countbandsTotalSum;
      this.countbandsTotal[1].amount = $(countband).toNumber();
      this.countbandsTotal[1].sum = $(sband).toFixed();
      this.countbandsTotal[2].amount = $(countpay).toNumber();
      this.countbandsTotal[2].sum = $(sumpay).toFixed();

      // --- проверить memory leak ---
      if (this.countbandsRowCount === 0) {
        if (this.oneCountbandGridApi) {
          this.oneCountbandColumnDefs[0].headerName = "";
          this.oneCountbandColumnDefs[0].headerTooltip = "";

          this.oneCountbandGridApi.setColumnDefs(this.oneCountbandColumnDefs);
        }
      }
      // --- проверить memory leak ---

      params.api.forEachNode(node => {
        if (node.data.nob === this.countbandsLastRow) {
          node.setSelected(true);
          params.api.ensureIndexVisible(node.rowIndex);
        } else {
          node.rowIndex ? 0 : node.setSelected(true);
        }
      });
    },
    onCountbandsRowSelected(params) {
      if (params.node.selected) {
        this.currentCountbandsRowSelected = params.node.data;

        const { nband } = this.currentCountbandsRowSelected;

        // --- проверить ---
        const headerName = `${this.calcOneCountbandName()}${nband}`;

        this.oneCountbandColumnDefs[0].headerName = headerName;
        this.oneCountbandColumnDefs[0].headerTooltip = headerName;

        this.oneCountbandGridApi.setColumnDefs(this.oneCountbandColumnDefs);
        // --- проверить ---

        this.refreshOneCountbandList();
      }
    },
    onCountbandsRowDoubleClicked() {
      this.onCountbandsEditBtn();
    },
    onOneCountbandGridReady(params) {
      this.oneCountbandGridApi = params.api;
      this.oneCountbandColumnApi = params.columnApi;

      const isCountband = this.type === "1";
      this.oneCountbandColumnApi.setColumnVisible("datebegin", !isCountband);
    },
    onOneCountbandFirstDataRendered(event) {
      setGridView(
        `wb-packs-grid-${this.calcLocalStorageName}-onecountband`,
        event,
        "optimal"
      );
    },
    onOneCountbandRowRightClicked(event) {
      this.setGridContextMenuKey(
        `wb-packs-grid-${this.calcLocalStorageName}-onecountband`
      );
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onOneCountbandModelUpdated(params) {
      // console.log("onOneCountbandModelUpdated");

      const rowCount = params.api.getDisplayedRowCount();

      this.oneCountbandAddBtnDisabled =
        this.countbandsRowCount === 0 ? true : false;
      this.oneCountbandEditBtnDisabled = this.oneCountbandDeleteBtnDisabled = this.oneCountbandDeleteAllBtnDisabled =
        rowCount === 0 ? true : false;

      const {
        sband,
        countband,
        spay,
        countpay,
        fullcount,
        fullspay
      } = this.oneCountbandTotalSum;
      this.oneCountbandTotal[0].amount = $(countband).toNumber();
      this.oneCountbandTotal[0].sum = $(sband).toFixed();
      this.oneCountbandTotal[1].amount = $(countpay).toNumber();
      this.oneCountbandTotal[1].sum = $(spay).toFixed();

      // Обновление полей кол-во и сумма в строке "По квитанции" для грида Бандероли/Листы
      this.countbandsTotal[2].amount = $(fullcount).toNumber();
      this.countbandsTotal[2].sum = $(fullspay).toFixed();

      params.api.forEachNode(node => {
        if (node.data.nop === this.oneCountbandLastRow) {
          node.setSelected(true);
          params.api.ensureIndexVisible(node.rowIndex);
        } else {
          node.rowIndex ? 0 : node.setSelected(true);
        }
      });
    },
    onOneCountbandRowSelected(params) {
      if (params.node.selected) {
        this.currentOneCountbandRowSelected = params.node.data;
      }
    },
    onOneCountbandRowDoubleClicked() {
      this.onOneCountbandEditBtn();
    },
    onPacksActiveTabClick(tab) {
      if (
        tab.name === "packSelected" &&
        this.packsActiveTabPrevious === "packList"
      ) {
        this.packsActiveTabPrevious = "packSelected";
        const {
          summa,
          quantity,
          countband,
          datebank,
          codefirme,
          isimport
        } = this.currentPackListRowSelected;
        const currentPack = {
          summa,
          quantity,
          countband,
          datebank,
          codefirme,
          isimport
        };

        this.setPackSelected(currentPack);

        this.refreshCountbandsList();
      } else if (
        tab.name === "packList" &&
        this.packsActiveTabPrevious === "packSelected"
      ) {
        this.packsActiveTabPrevious = "packList";
        this.clearPackSelected();
        this.clearCountbands();
        this.clearOneCountband();
      }
    },
    refreshPackList() {
      const typeform = this.type;

      if (this.packListGridOptions.api) {
        this.packListGridOptions.api.setRowData([]);
        this.packListGridOptions.api.showLoadingOverlay();
      }
      this.getPackList({ typeform });
    },
    refreshCountbandsList() {
      const { npack } = this.currentPackListRowSelected;

      if (this.countbandsGridOptions.api) {
        this.countbandsGridOptions.api.setRowData([]);
        this.countbandsGridOptions.api.showLoadingOverlay();
      }

      this.clearCountbands();
      this.getCountbands({ npack });
    },
    refreshOneCountbandList() {
      const { npack } = this.currentPackListRowSelected;
      const { nband } = this.currentCountbandsRowSelected;

      if (this.oneCountbandGridOptions.api) {
        this.oneCountbandGridOptions.api.setRowData([]);
        this.oneCountbandGridOptions.api.showLoadingOverlay();
      }
      this.getOneCountband({ npack, nband });
    },
    reasonReturningPackModalHide() {
      this.reasonReturningPackForm = {
        codereasonCode: null,
        codereason: null
      };
    },
    reasonReturningPackSubmit() {
      this.$refs.reasonReturningPackForm.validate(valid => {
        if (valid) {
          const { npack, datebeginfact } = this.currentPackListRowSelected;
          const { codereason } = this.reasonReturningPackForm;

          this.reasonReturningPackModal = false;

          this.currentPackListLastRow = null;
          this.clearReturnPack();
          this.callReturnPack({ npack, datebeginfact, codereason });
        }
      });
    },
    onReturnBtn() {
      this.$confirm(this.$t("packs.packListTab.confirm.onReturnBtn"), "", {
        confirmButtonText: this.$t("common.buttons.confirmYes"),
        cancelButtonText: this.$t("common.buttons.confirmNo"),
        cancelButtonClass: "cancel-button",
        type: "info"
      })
        .then(() => {
          this.reasonReturningPackModal = true;
        })
        .catch(() => {});
    },
    onPostingBtn() {
      const { npack, datebeginfact } = this.currentPackListRowSelected;

      this.clearPostingPrepare();
      this.callPostingPrepare({ npack, datebeginfact });
    },
    onPostponeBtn() {
      this.$confirm(this.$t("packs.packListTab.confirm.onPostponeBtn"), "", {
        confirmButtonText: this.$t("common.buttons.confirmYes"),
        cancelButtonText: this.$t("common.buttons.confirmNo"),
        cancelButtonClass: "cancel-button",
        type: "info"
      })
        .then(() => {
          this.pressedButton = "postpone";
          const { npack } = this.currentPackListRowSelected;
          this.getPackVerification({ npack });
        })
        .catch(() => {});
    },
    onPostingAllBtn() {
      this.$confirm(this.$t("packs.packListTab.confirm.onPostingAllBtn"), "", {
        confirmButtonText: this.$t("common.buttons.confirmYes"),
        cancelButtonText: this.$t("common.buttons.confirmNo"),
        cancelButtonClass: "cancel-button",
        type: "info"
      })
        .then(() => {
          this.clearPostingAllPrepare();
          this.callPostingAllPrepare();
        })
        .catch(() => {});
    },
    onCheckBtn() {
      this.pressedButton = "check";
      const { npack } = this.currentPackListRowSelected;
      this.getPackVerification({ npack });
    },
    onInfoPayBtn() {
      const { npack } = this.currentPackListRowSelected;
      this.getInfoPay({ npack });
    },
    onRefreshPackListBtn() {
      this.currentPackListLastRow = null;
      this.refreshPackList();
    },
    currentPackIsImport() {
      const { isimport } = this.currentPackSelectedRowSelected;

      if (isimport === "1") {
        this.$alert(
          this.$t("packs.packSelectedTab.alert.importPackIsNotChanged"),
          "",
          {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type: "warning"
          }
        );
      }

      return isimport === "1" ? true : false;
    },
    calcNextCountband(countbands) {
      // расчет следующего "Номера бандероли"
      const maxNumber = countbands.reduce(
        (prev, cur) => (+cur.nband > +prev.nband ? cur : prev),
        { nband: 0 }
      );
      let nextNband = +maxNumber.nband;

      // расчет следующего "Кол-во квитанций" и "Общая сумма"
      const totalCountpay = countbands.reduce(
        (prev, cur) => prev + $(cur.countpay).toNumber(),
        0
      );
      const totalSummband = countbands.reduce(
        (prev, cur) => prev + $(cur.summband).toNumber(),
        0
      );

      const { quantity, summa } = this.currentPackSelectedRowSelected;

      const nextCountpay = $(quantity)
        .minus($(totalCountpay))
        .toNumber();
      const nextSummband = $(summa)
        .minus($(totalSummband))
        .toNumber();

      this.countbandsEditForm = {
        number: ++nextNband,
        quantity: nextCountpay,
        totalSum: nextSummband
      };
    },
    onCountbandsAddBtn() {
      if (!this.currentPackIsImport()) {
        const { countband } = this.currentPackSelectedRowSelected;

        if (this.countbandsRowCount < $(countband).toNumber()) {
          this.countbandsEditStatus = "add";
          this.calcNextCountband(this.countbands);
          this.countbandsEditModal = true;
        } else {
          const message =
            this.type === "1"
              ? this.$t(
                  "packs.packSelectedTab.alert.maxCountbandsHasAlreadyBeenEntered"
                )
              : this.$t(
                  "packs.packSelectedTab.alert.maxListsHasAlreadyBeenEntered"
                );
          this.$alert(message, "", {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type: "info"
          });
        }
      }
    },
    onCountbandsEditBtn() {
      if (!this.currentPackIsImport()) {
        this.countbandsEditStatus = "edit";

        const { nband, countpay, summband } = this.currentCountbandsRowSelected;
        this.countbandsEditForm = {
          number: nband,
          quantity: $(countpay).toNumber(),
          totalSum: $(summband).toNumber()
        };

        this.countbandsEditModal = true;
      }
    },
    onCountbandsDeleteBtn() {
      if (!this.currentPackIsImport()) {
        const message =
          this.type === "1"
            ? this.$t("packs.packSelectedTab.alert.deleteCountband")
            : this.$t("packs.packSelectedTab.alert.deleteList");
        this.$confirm(message, "", {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "info"
        })
          .then(() => {
            const { nob } = this.currentCountbandsRowSelected;

            this.clearCountbandsDelete();
            this.callCountbandsDelete({ nob });
          })
          .catch(() => {});
      }
    },
    calcTitleCountbandPayment(kindpay) {
      const countband = `${$(this.oneCountbandTotal[0].amount).toNumber()}/${$(
        this.oneCountbandTotal[0].sum
      ).toFixed()}`;
      const receipt = `${$(this.oneCountbandTotal[1].amount).toNumber()}/${$(
        this.oneCountbandTotal[1].sum
      ).toFixed()}`;

      let title = "";
      switch (kindpay) {
        case "88":
          title = this.$t(
            "packs.packSelectedTab.paymentTitle.compensationForVisuallyImpaired",
            { countband, receipt }
          );
          break;
        case "91":
          title = this.$t("packs.packSelectedTab.paymentTitle.socialSurcharg", {
            countband,
            receipt
          });
          break;
        case "99":
          title = this.$t("packs.packSelectedTab.paymentTitle.subsidy", {
            countband,
            receipt
          });
          break;
        default:
          title = this.$t("packs.packSelectedTab.paymentTitle.receipt", {
            countband,
            receipt
          });
      }
      return title;
    },
    onOneCountbandAddBtn() {
      if (!this.currentPackIsImport()) {
        const { countpay, nband } = this.currentCountbandsRowSelected;
        const { npack, kindpay, datebank } = this.currentPackListRowSelected;
        const amount = this.oneCountbandTotal[1].amount;

        if ($(amount).toNumber() < $(countpay).toNumber()) {
          // расчет title для Payments
          const title = this.calcTitleCountbandPayment(kindpay);
          const nop = "null"; // в режиме создания платежа поле не используется

          this.setCountbandPayment({ title, nband, amount, nop });

          // формирование начальных данных и неявный вызов формы "Платежи" в режиме создания платежа
          const payload = {
            state: "add",
            npack,
            payid: "", // поле только для редактирования и удаления платежей
            date: datebank,
            sumPay: 0,
            kindpay,
            countpay: $(countpay).toNumber(), // кол-во допуступных для добавления платежей
            note: ""
          };
          this.$store.commit("setPaymentData", payload);
          this.$store.commit("setPaymentModal", true);
        } else {
          const message =
            this.type === "1"
              ? this.$t(
                  "packs.packSelectedTab.alert.maxReceiptsHasAlreadyBeenEntered"
                )
              : this.$t(
                  "packs.packSelectedTab.alert.maxSubsidiesHasAlreadyBeenEntered"
                );
          this.$alert(message, "", {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type: "warning"
          });
        }
      }
    },
    onOneCountbandEditBtn() {
      if (!this.currentPackIsImport()) {
        const { npack, kindpay, datebank } = this.currentPackListRowSelected;

        // расчет title для Payments
        const title = this.calcTitleCountbandPayment(kindpay);
        const nband = "null"; // в режиме редактирования платежа поле не используется
        const amount = "null"; // в режиме редактирования платежа поле не используется
        const { nop } = this.currentOneCountbandRowSelected;

        this.setCountbandPayment({ title, nband, amount, nop });

        // формирование начальных данных и неявный вызов формы "Платежи" в режиме редактирования платежа
        const payload = {
          state: "edit",
          npack,
          payid: "", // поле только для редактирования и удаления платежей
          date: datebank,
          sumPay: 0,
          kindpay,
          countpay: 0, // поле только для добавления платежей
          note: ""
        };
        this.$store.commit("setPaymentData", payload);
        this.$store.commit("setPaymentModal", true);
      }
    },
    onOneCountbandDeleteBtn() {
      if (!this.currentPackIsImport()) {
        this.$confirm(
          this.$t("packs.packSelectedTab.confirm.deletePayment"),
          "",
          {
            confirmButtonText: this.$t("common.buttons.confirmYes"),
            cancelButtonText: this.$t("common.buttons.confirmNo"),
            cancelButtonClass: "cancel-button",
            type: "info"
          }
        )
          .then(() => {
            const { nop } = this.currentOneCountbandRowSelected;

            this.clearOneCountbandPaymentDelete();
            this.countbandPaymentOneDelete({ nop });
          })
          .catch(() => {});
      }
    },
    onOneCountbandDeleteAllBtn() {
      if (!this.currentPackIsImport()) {
        const message =
          this.type === "1"
            ? this.$t("packs.packSelectedTab.confirm.deleteAllCountband")
            : this.$t("packs.packSelectedTab.confirm.deleteAllList");
        this.$confirm(message, "", {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "info"
        })
          .then(() => {
            const { npack } = this.currentPackListRowSelected;
            const { nband } = this.currentCountbandsRowSelected;

            this.clearOneCountbandPaymentDelete();
            this.countbandPaymentAllDelete({ npack, nband });
          })
          .catch(() => {});
      }
    },
    countbandsTotalTableCellStyle({ row, column, rowIndex, columnIndex }) {
      let style;
      const packAmount = this.countbandsTotal[0].amount;
      const packSum = this.countbandsTotal[0].sum;

      // По пачке
      if (column.property === "amount" && rowIndex === 0 && columnIndex === 1) {
        style = "";
      }
      if (column.property === "sum" && rowIndex === 0 && columnIndex === 2) {
        style = "";
      }

      // По бандеролям
      if (column.property === "amount" && rowIndex === 1 && columnIndex === 1) {
        const val = row[column.property];
        style = val !== packAmount ? "table-cell-red" : "";
      }
      if (column.property === "sum" && rowIndex === 1 && columnIndex === 2) {
        const val = row[column.property];
        style = val !== packSum ? "table-cell-red" : "";
      }

      // По квитанциям
      if (column.property === "amount" && rowIndex === 2 && columnIndex === 1) {
        const val = row[column.property];
        style = val !== packAmount ? "table-cell-red" : "";
      }
      if (column.property === "sum" && rowIndex === 2 && columnIndex === 2) {
        const val = row[column.property];
        style = val !== packSum ? "table-cell-red" : "";
      }

      return `table-cell-border ${style}`;
    },
    oneCountbandTotalTableCellStyle({ row, column, rowIndex, columnIndex }) {
      let style;
      const countBandAmount = this.oneCountbandTotal[0].amount;
      const countBandSum = this.oneCountbandTotal[0].sum;

      // По бандеролям
      if (column.property === "amount" && rowIndex === 0 && columnIndex === 1) {
        style = "";
      }
      if (column.property === "sum" && rowIndex === 0 && columnIndex === 2) {
        style = "";
      }

      // По квитанциям
      if (column.property === "amount" && rowIndex === 1 && columnIndex === 1) {
        const val = row[column.property];
        style = val !== countBandAmount ? "table-cell-red" : "";
      }
      if (column.property === "sum" && rowIndex === 1 && columnIndex === 2) {
        const val = row[column.property];
        style = val !== countBandSum ? "table-cell-red" : "";
      }

      return `table-cell-border ${style}`;
    },
    countbandsEditModalHide() {
      this.countbandsEditStatus = "";
      this.countbandsSubmitStatus = "";

      this.countbandsEditForm = {
        number: 0,
        quantity: 0,
        totalSum: 0
      };
    },
    countbandsEditFormSubmit(type) {
      this.$refs.countbandsEditForm.validate(valid => {
        if (valid) {
          const { number, quantity, totalSum } = this.countbandsEditForm;

          this.countbandsSubmitStatus = type;

          if (this.countbandsEditStatus === "add") {
            const { npack } = this.currentPackListRowSelected;

            this.clearCountbandsEdit();
            this.callCountbandsInsert({ npack, number, quantity, totalSum });
          } else if (this.countbandsEditStatus === "edit") {
            const { nob } = this.currentCountbandsRowSelected;

            this.clearCountbandsEdit();
            this.callCountbandsEdit({ nob, number, quantity, totalSum });
          }
        }
      });
    },
    onChangeReasonRetPackCodereasonCode(event) {
      const value = event.target.value;
      const reasons = this.params.codereason.data.filter(
        item => item.codereason === value
      );
      if (reasons.length > 0) {
        this.reasonReturningPackForm.codereason = value;
      } else {
        this.reasonReturningPackForm.codereason = null;
        this.reasonReturningPackForm.codereasonCode = null;
      }
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        // Packs:packSelected - Ins, "+" Добавить бандероль
        case "Insert":
        case "Plus":
          if (
            !this.countbandsAddBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.onCountbandsAddBtn();
            // Packs:packSelected:countbandsEditModal - Ins, "+" Добавить бандероль
          } else if (
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            this.countbandsEditModal &&
            this.countbandsEditStatus === "add" &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.countbandsEditFormSubmit("insert");
          }
          break;
        // Packs:packSelected - F4, "*" Редактировать бандероль
        case "F4":
        case "Star":
          if (
            !this.countbandsEditBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.onCountbandsEditBtn();
          }
          break;
        // Packs:packList - Del, "-" Вернуть
        case "Del":
        case "Minus":
          if (
            !this.returnBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packList"
          ) {
            this.onReturnBtn();
            // Packs:packSelected - Del, "-" Удалить бандероль
          } else if (
            !this.countbandsDeleteBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.onCountbandsDeleteBtn();
          }
          break;
        // Packs:packSelected - Ctrl+Ins, Ctrl+"+" Добавить платеж
        case "CtrlInsert":
        case "CtrlPlus":
          if (
            !this.oneCountbandAddBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.onOneCountbandAddBtn();
          }
          break;
        // Packs:packSelected - Ctrl+F4, Ctrl+"*" Редактировать платеж
        case "CtrlF4":
        case "CtrlStar":
          if (
            !this.oneCountbandEditBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.onOneCountbandEditBtn();
          }
          break;
        // Packs:packSelected - Ctrl+Del, Ctrl+"-" Удалить платеж
        case "CtrlDel":
        case "CtrlMinus":
          if (
            !this.oneCountbandDeleteBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.onOneCountbandDeleteBtn();
          }
          break;
        // Packs:packSelected - Shift+Del, Shift+"-" Удалить все платежи
        case "ShiftDel":
        case "ShiftMinus":
          if (
            !this.oneCountbandDeleteAllBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.onOneCountbandDeleteAllBtn();
          }
          break;
        // Packs:packList - Enter переход из вкладки 'Список пачек' на вкладку 'Пачка №ХХХХХХХ'
        case "Enter":
          if (
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packList" &&
            this.packSelectedVisible
          ) {
            this.packsActiveTabName = "packSelected";

            const tab = { name: "packSelected" };
            this.onPacksActiveTabClick(tab);
          }
          break;
        // Packs:packList - F9 Разнести
        case "F9":
          if (
            !this.postingBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packList"
          ) {
            this.onPostingBtn();
          }
          break;
        // Packs:packList:reasonReturningPackModal - F10 Подтвердить
        case "F10":
          if (
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.countbandsEditModal &&
            this.reasonReturningPackModal &&
            this.packsActiveTabName === "packList"
          ) {
            this.reasonReturningPackSubmit();
            // Packs:packSelected:countbandsEditModal - F10 Подтвердить
          } else if (
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            this.countbandsEditModal &&
            this.packsActiveTabName === "packSelected"
          ) {
            this.countbandsEditFormSubmit("submit");
          }
          break;
        // Packs:packList - F11 Проверить
        case "F11":
          if (
            !this.checkBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal
          ) {
            this.onCheckBtn();
          }
          break;
        // Packs:packList - Shift+F9 Отложить
        case "ShiftF9":
          if (
            !this.postponeBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packList"
          ) {
            this.onPostponeBtn();
          }
          break;
        // Packs:packList - Ctrl+F9 Разнести все
        case "CtrlF9":
          if (
            !this.postingAllBtnDisabled &&
            !this.errorPaymentsModal &&
            !this.paymentModal &&
            !this.reasonReturningPackModal &&
            !this.countbandsEditModal &&
            this.packsActiveTabName === "packList"
          ) {
            this.onPostingAllBtn();
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-container-packs {
  height: calc(100vh - 230px);
  overflow-y: auto;
}

.grid-container-packSelected {
  height: 80px;
  overflow-y: auto;
}

.grid-container-countbands {
  height: calc(100vh - 395px);
  overflow-y: auto;
}

.grid-container-onecountband {
  height: calc(100vh - 367px);
  overflow-y: auto;
}

.red-star {
  color: red;
  margin-right: 3px;
}

.blank-element {
  background-color: white;
  border: 1px solid #7c9eb8;
}
</style>

<style lang="scss">
.el-table--border,
.el-table--group {
  border-bottom: 1px solid #7c9eb8;
  border-right: 1px solid #7c9eb8;
}

.el-table .cell {
  line-height: 14px;
}

.table-cell-border {
  border: 1px solid #7c9eb8;
}

.table-cell-red {
  color: red;
}

.el-input-number .el-input__inner {
  text-align: left;
}
</style>
